// ZahlungKasten.jsx — offene Startgebühr eines Turniers bezahlen (Aufgabe 141, 02.10.2026)
//
// Lädt erst auf Klick (nicht für jedes Turnier sofort): offener Betrag,
// Bankverbindung, Verwendungszweck und GiroCode (QR zur Überweisung —
// Banking-App scannen, alles ausgefüllt). Backend: GET /api/zahlung/verein/…
import React, { useState } from 'react';

const euro = (b) => `${Number(b || 0).toFixed(2).replace('.', ',')} €`;

export default function ZahlungKasten({ turnierId, vereinsId, headers }) {
  const [offen, setOffen] = useState(false);
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState('');

  const laden = async () => {
    setOffen((o) => !o);
    if (daten || offen) return;
    try {
      const r = await fetch(`/api/zahlung/verein/${turnierId}/${vereinsId}`, { headers });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.success) throw new Error(d.error || `HTTP ${r.status}`);
      setDaten(d);
    } catch (e) { setFehler(e.message); }
  };

  return (
    <div className="vd-zahlung">
      <button type="button" className="vd-btn vd-btn--ghost" onClick={laden}>💳 {offen ? 'Zahlung ausblenden' : 'Bezahlen'}</button>
      {offen && (
        <div className="vd-zahlung-inhalt">
          {fehler && <p className="vd-zahlung-hinweis">⚠️ {fehler}</p>}
          {!daten && !fehler && <p className="vd-zahlung-hinweis">Lädt …</p>}
          {daten && daten.betrag_offen <= 0 && <p className="vd-zahlung-hinweis">✓ Für dieses Turnier ist nichts offen.</p>}
          {daten && daten.betrag_offen > 0 && (
            <div className="vd-zahlung-zeile">
              {daten.girocode && <img src={daten.girocode} alt="GiroCode zur Überweisung" className="vd-zahlung-qr" />}
              <div className="vd-zahlung-text">
                <div className="vd-zahlung-betrag">Offen: {euro(daten.betrag_offen)}</div>
                {daten.bank ? (
                  <>
                    <p className="vd-zahlung-hinweis">Mit der Banking-App scannen — Empfänger, Betrag und Verwendungszweck sind ausgefüllt.</p>
                    <dl className="vd-zahlung-bank">
                      <dt>Empfänger</dt><dd>{daten.bank.kontoinhaber}</dd>
                      <dt>IBAN</dt><dd>{daten.bank.iban}</dd>
                      {daten.bank.bic && <><dt>BIC</dt><dd>{daten.bank.bic}</dd></>}
                      <dt>Verwendungszweck</dt><dd>{daten.verwendungszweck}</dd>
                    </dl>
                  </>
                ) : <p className="vd-zahlung-hinweis">⚠️ {daten.hinweis}</p>}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
